const apiURL = [];
apiURL.socketAPI = 'https://api.esen.edu.sv'
apiURL.fetchAPI = 'https://api.esen.edu.sv/api/'
    // apiURL.fetchAPI = 'http://localhost:3000/api/'
apiURL.fotoAPI = 'https://api.esen.edu.sv/'
export default apiURL;